import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProductSectionProps {
  $bgColor?: string;
  $textColor?: string;
}

export const ProductSection = styled.div<IProductSectionProps>`
  padding: 24px 0;
  background: #fff;
  text-align: center;

  ${({ $bgColor, $textColor }) =>
    $bgColor &&
    css`
      background: ${$bgColor};

      .main-title,
      .sub-title,
      .swiper-pagination-fraction {
        color: ${$textColor};
      }

      .category-menubar {
        .item.active .area-click {
          color: ${$textColor} !important;

          &:after {
            background: ${$textColor} !important;
          }
        }
      }

      .product-item .tag.tag-soldout {
        background: rgba(172, 172, 172, 0.15);
        color: #000;
      }

      .btn-section-more {
        .text {
          color: ${$textColor};
        }

        svg path {
          stroke: ${$textColor};
        }
      }

      .swiper-button-next svg path,
      .swiper-button-prev svg path {
        fill: ${$textColor};
      }
    `}

  &.bg-type-black {
    background: #000;

    .main-title {
      color: #fff;
    }

    .swiper-navigation-bottom01 {
    }

    .btn-section-more {
      border-color: #555;

      .text {
        color: #fff;
      }

      svg path {
        stroke: #fff;
      }
    }
  }

  .section-title {
    padding-bottom: 0;

    + .img-wrap,
    + .product-list {
      margin-top: 16px;
    }
  }

  .category-tab {
    margin-top: 12px;
  }

  .img-wrap {
    position: relative;
    height: ${mixin.pxToVw('170')};
    ${mixin.flex({
      direction: 'column',
      justify: 'center',
    })}

    .img {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;

      &:after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.1);
      }
    }

    .text {
      width: 100%;
      padding: 0 20px;
      z-index: 1;
    }

    .banner-text + .banner-sub-text {
      margin-top: 4px;
    }
  }

  .product-list {
    margin-top: 20px;
    padding: 0 20px;
  }

  .btn-section-more {
    background: transparent;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('24 0')};

    .section-title {
      + .img-wrap,
      + .product-list {
        margin-top: ${mixin.pxToVw('16')};
      }
    }

    .category-tab {
      margin-top: ${mixin.pxToVw('12')};
    }

    .img-wrap {
      .text {
        padding: ${mixin.pxToVw('0 20')};
      }

      .banner-text + .banner-sub-text {
        margin-top: ${mixin.pxToVw('4')};
      }
    }

    .product-list {
      margin-top: ${mixin.pxToVw('20')};
      padding: ${mixin.pxToVw('0 20')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 54px 57px;

    .section-title {
      + .img-wrap,
      + .product-list {
        margin-top: 20px;
      }
    }

    .category-tab {
      margin-top: 20px;
    }

    .img-wrap {
      margin-top: 30px;
      height: 170px;

      .banner-text {
        font-size: 30px;
      }

      .banner-sub-text {
        font-size: 18px;
      }
    }

    .product-list {
      margin-top: 30px;
      padding: 0;
    }
  }
`;
